module.exports = __webpack_public_path__ + "img/abstract-shapes-7.ae4b6289.svg";